import { createContext, useContext, useState } from "react";
import { QuoteModal } from "@/components/site/QuoteModal";

const Ctx = createContext({ open: () => {} });
export const useQuote = () => useContext(Ctx);

export const QuoteProvider = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <Ctx.Provider value={{ open: () => setOpen(true) }}>
      {children}
      <QuoteModal open={isOpen} onOpenChange={setOpen} />
    </Ctx.Provider>
  );
};
